import * as React from 'react';
import { Button, Modal, Container, Checkbox } from '../../../Components';
import styled from 'styled-components';

interface IModalProps {
  isOpen: boolean;
  outterClick: (() => void);
  aprovar: () => void;
}

const StyledModal = styled(Modal)`
  height: fit-content;
  min-height: 200px;
`;

const ContainerGrid = styled(Container)`
  grid-template-columns: repeat(12, 1fr);
  padding-left: 30px;
`;

const StyledTitle = styled.span`
  font-size: 18;
  padding: 10px 0px 0px 0px;
  font-weight: 500;
  grid-column: 1/12;
`;

const StyledSubTitle = styled.span`
  color: gray;
  font-size: 13px;
  padding: 5px 0px 5px 0px;
  grid-column: 1/12;
`;

const StyledContainerButtom = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 0px 20px 0px 20px;
  margin: 10px 0px;
  margin-right: 60px;

  @media(max-width: 640px) {
    flex-direction: column;
    justify-content: center;
    margin-right: 0px;
  }
`;

const StyledCheckbox = styled(Checkbox)`
  margin-right: 10px

  @media(max-width: 640px) {
    margin-right: 0px
  }
`;

const StyledButton = styled(Button)`
  margin-left: 16px;

  @media(max-width: 640px) {
    margin-left: 0px;
    margin-top: 14px;
  }
`;

const InstrucoesPreProjetoAceitoModal: React.FC<IModalProps> = (props: IModalProps) => {
  const { isOpen, outterClick, aprovar } = props;
  const [ciente, setCiente] = React.useState(false)

  const onCancel = () => {
    setCiente(false)
    outterClick()
  }

  return (
    <StyledModal
      size='medium'
      outterClick={onCancel}
      isVisible={isOpen}
    >
      <ContainerGrid>
        <StyledTitle>Aceitar Orientação</StyledTitle>
        <StyledSubTitle>
          Informação sigilosa até o fim da presente fase do processo seletivo.
          Não divulgar suas escolhas. O aluno será informado automaticamente nos próximos dias,
          por edital e comunicação da secretaria.
        </StyledSubTitle>
      </ContainerGrid>

      <StyledContainerButtom>
        <StyledCheckbox label='Ciente' checked={ciente} onChange={(e) => setCiente(e.target.checked)} />
        <StyledButton
          type='submit'
          color='approvedColor'
          onClick={aprovar}
          disabled={!ciente}
        >
          ACEITAR
        </StyledButton>
        <StyledButton
          onClick={onCancel}
        >
          SAIR
        </StyledButton>
      </StyledContainerButtom>
    </StyledModal>
  );
};

export default InstrucoesPreProjetoAceitoModal;
